import React, {FunctionComponent, useState} from 'react';

import { ButtonCountdown} from 'components';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader} from '@cfa/react-components';
import {AsyncStatus} from 'enums';
import { UpdatePageModel } from '../UpdatePageModel';

interface IDeleteModalProps {
    model: UpdatePageModel,
    onCancel: () => void,
    onSuccess: () => void,
    show: boolean,
}

export const DeleteModal: FunctionComponent<IDeleteModalProps> = function(props) {
    const { model, onCancel, onSuccess, show } = props;
    if (!model.update) return null;

    const [status, setStatus] = useState(AsyncStatus.Initial);
    const [err, setErr] = useState('');

    function tryHide() {
        // Prevent closing the modal if an API call is in progress.
        if (status !== AsyncStatus.Loading) {
            onCancel();
        }
    }

    function onConfirm() {
        if (status === AsyncStatus.Loading) return;

        setStatus(AsyncStatus.Loading);
        model.delete()
            .then(onSuccess)
            .catch(() => {
                setStatus(AsyncStatus.Error);
                setErr(model.apiCallError);
            });
    }

    return (
        <Modal show={show} onClose={tryHide}>
            <ModalHeader>
                Delete Update
            </ModalHeader>
            <ModalBody>
                <p>
                    Are you sure you want to permanently delete this update "<b>{model.update.name}</b>"?
                </p>
                {status === AsyncStatus.Error && (
                    <p className="deleteUpdateModal_error">
                        We're sorry, an error has occurred: {err}
                    </p>
                )}
            </ModalBody>
            <ModalFooter>
                <Button
                    variant="outlined"
                    onClick={tryHide}
                    disabled={status === AsyncStatus.Loading}
                >
                    Cancel
                </Button>
                <ButtonCountdown
                    style={{marginLeft: "10px"}}
                    onClick={onConfirm}
                    loading={status === AsyncStatus.Loading}
                    disabled={status === AsyncStatus.Success}
                >
                    {status === AsyncStatus.Loading && 'Deleting update...'}
                    {status !== AsyncStatus.Loading && 'Delete update'}
                </ButtonCountdown>
            </ModalFooter>
        </Modal>
    );
}